<template>
  <Dialog :modelValue="modelValue" @update:modelValue="emit('update:modelValue', $event)" @close="emit('close')">
    <div class="dialog">
      <div class="dialog-title">
        <span class="dialog-title-text">{{ t('halloween.share') }}</span>
      </div>
      <div class="dialog-content-wrap">
        <div class="share-channels">
          <button type="button" class="share-channel" @click="shareToFB">
            <img :src="facebookImg" alt="facebook">
          </button>
          <button type="button" class="share-channel" @click="shareToX">
            <img :src="xImg" alt="x">
          </button>
          <button type="button" class="share-channel" @click="shareToWhatsApp">
            <img :src="whatsappImg" alt="whatsapp">
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import Dialog from '../index.vue'
import facebookImg from '@/assets/imgs/act/mwr/share/facebook.png'
import xImg from '@/assets/imgs/act/mwr/share/x.png'
import whatsappImg from '@/assets/imgs/act/mwr/share/whatsapp.png'

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'close', 'shareSuccess'])
const { t } = useI18n()

const sharePageUrl = () => encodeURIComponent(window.location.href)
const shareText = () => encodeURIComponent(`${t('halloween.shareTitle')}\n${t('halloween.shareContent')}`)

const afterShare = () => {
  emit('shareSuccess')
  emit('update:modelValue', false)
}

const shareToFB = () => {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${sharePageUrl()}&quote=${shareText()}`,
    '_blank',
  )
  afterShare()
}

const shareToX = () => {
  window.open(
    `https://twitter.com/intent/tweet?url=${sharePageUrl()}&text=${shareText()}`,
    '_blank',
  )
  afterShare()
}

const shareToWhatsApp = () => {
  window.open(`https://wa.me/?text=${shareText()}%0A${sharePageUrl()}`, '_blank')
  afterShare()
}
</script>

<style scoped lang="less">
.dialog {
  overflow: hidden;

  .dialog-title {
    width: 424px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/halloween/assets/img/dialog-title-bg.png') no-repeat center center / 100% 100%;
    margin: 0 auto;
    margin-top: -10px;
  }

  .dialog-title-text {
    margin-top: 6px;
    color: #fff;
    font-size: 32px;
    font-weight: 900;
    letter-spacing: 1px;
    text-shadow:
      0 2px 0 #3b2fe0,
      2px 0 0 #3b2fe0,
      -2px 0 0 #3b2fe0,
      0 -2px 0 #3b2fe0,
      0 4px 0 #24168a;
  }

  .dialog-content-wrap {
    width: 608px;
    height: 396px;
    margin: 30px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('~@/views/act/halloween/assets/img/dialog-inner-bg.png') no-repeat center center / 100% 100%;
  }
}

.share-channels {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
}

.share-channel {
  width: 72px;
  height: 72px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
